import { Alert, Button, Form, Input, message, Modal, Tooltip } from "antd"
import { useCallback, useEffect, useState } from "react"
import apiCalls from "src/api/apiCalls"
import { replaceExtraSpaces, validateAlphanumericWithSpace, validations } from "src/utils/custom.validator"
import Loader from "../loader.component"
import { isErrorMessage } from "../shared/error.message"
const RoleAddEdit = ({ id, mode, isModal, closeModal, setIsRefresh }) => {
    const [errorMessage, setErrorMessage] = useState(null)
    const [data, setData] = useState([])
    const [loader, setLoader] = useState(false)
    const [buttonLoader, setButtonLoader] = useState(false)
    const [form] = Form.useForm();
    useEffect(() => {
        if (mode == "Edit" && id) {
            getEditData(id)
        }
    }, [mode, id])
    const handleCloseModal = useCallback(() => {
        form.resetFields()
        closeModal()
    }, [closeModal, form])
    const getEditData = async (id) => {
        try {
            setLoader(true)
            const response = await apiCalls.getRoleData(id);
            if (response.ok) {
                setData(response.data);
                form.setFieldsValue(response.data);
                setErrorMessage(null);
            } else {
                setErrorMessage(isErrorMessage(response?.data));
            }
        } catch (error) {
            setErrorMessage(error.message);
        } finally {
            setLoader(false)
        }
    };
    const addRoleSave = async (value) => {
        let saveObject = {
            "extraProperties": {},
            "name": value?.name,
            "isDefault": false,
            "isPublic": false
        };
        try {
            setButtonLoader(true)
            const response = await apiCalls.addRole(saveObject);
            if (response.ok) {
                handleCloseModal()
                setIsRefresh(true)
                message.success({
                    content: "Role Saved Successfully.",
                    className: "custom-msg",
                    duration: 3,
                });
                setData([])
                setErrorMessage(null);
            } else {
                setErrorMessage(isErrorMessage(response?.data));
            }
        } catch (error) {
            setErrorMessage(error.message);
        } finally {
            setButtonLoader(false)
        }
    };
    const editRoleSave = async (id, value) => {
        let saveObject = {
            "name": value.name,
            "isDefault": data?.isDefault,
            "isStatic": data?.isStatic,
            "isPublic": data?.isPublic,
            "concurrencyStamp": data?.concurrencyStamp,
            "id": data?.id,
            "extraProperties": {}
        };
        try {
            setButtonLoader(true)
            const response = await apiCalls.editRole(id, saveObject);
            if (response.ok) {
                handleCloseModal()
                setIsRefresh(true)
                message.success({
                    content: "Role Saved Successfully.",
                    className: "custom-msg",
                    duration: 3,
                });
                setErrorMessage(null);
                setData([])
            } else {
                setErrorMessage(isErrorMessage(response?.data));
            }
        } catch (error) {
            setErrorMessage(error);
        } finally {
            setButtonLoader(false)
        }
    };
    const handleSave = useCallback((value) => {
        if (mode == "Add") {
            addRoleSave(value)
        } else {
            editRoleSave(id, value)
        }
    }, [mode])
    const closeError = useCallback(() => {
        setErrorMessage(null)
    }, [])
    const handleOnBlur = useCallback((e) => {
        form.setFieldsValue({ name: replaceExtraSpaces(e.target.value) });
    })
    return (
        <Modal
            open={isModal}
            onCancel={handleCloseModal}
            title={`${mode} Role`}
            maskClosable={false}
            closeIcon={
                <Tooltip title="Close">
                    <span className="icon close c-pointer" />
                </Tooltip>
            }
            footer={""}>
            <div className=''>
                {loader ? <Loader /> : <>
                    {errorMessage &&
                        <div className='mb-4'>
                            <Alert
                                className=''
                                type="error"
                                description={errorMessage}
                                onClose={closeError}
                                showIcon
                                closable
                            />
                        </div>
                    }
                    <div className="">
                        <Form form={form} onFinish={handleSave}>
                            <div className="grid grid-cols-1">
                                <Form.Item colon={false} name="name" label={"Role Name"} className=" custom-input input-label  floatinput-label !text-whiteText" rules={[
                                    validations.requiredValidator(),
                                    { validator: validateAlphanumericWithSpace("role name") },
                                ]}>
                                    <Input maxLength={20} placeholder="Enter Role Name" fieldName="Role Name" onBlur={handleOnBlur} />
                                </Form.Item>
                            </div>
                            <div className='mt-4 md:flex justify-end gap-2 space-y-2 md:space-y-0'>
                                <Button className='cancel-btn !py-5' key="back" onClick={handleCloseModal}>Cancel</Button>
                                <Button className='primary-btn' type="primary" htmlType="submit" loading={buttonLoader}>Save</Button>
                            </div>
                        </Form>
                    </div>
                </>}
            </div>
        </Modal>
    )
}
export default RoleAddEdit